
export type CheckEnrollmentEligibility200 = {
  /** 수용 인원 여유 여부 */
  capacityAvailable: boolean;
  /** 수강 가능 여부 */
  eligible: boolean;
  /** 결제 필요 여부 */
  paymentRequired: boolean;
  /** 전제 조건 충족 여부 */
  prerequisitesMet: boolean;
  /** 수강 불가 사유 목록 */
  reasons?: string[];
  /**
   * 필요 결제 금액
   * @nullable
   */
  requiredPaymentAmount?: number | null;
};
